import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PagesStepper from '../PagesStepper';

const useStyles = makeStyles(() => ({
  boxTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
  },
}));

const WidgetBox = function WidgetBox({
  top = null,
  left = null,
  widget = null,
  title = null,
  titleSectionStyle = null,
  titleWidget = null,
  width = null,
  height = null,
  flex = null,
  pages = 1,
  currentPage = 0,
  handleChangePage = null,
}) {
  const classes = useStyles();

  return (
    <Paper
      sx={{
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '18px',
      }}
      style={{ width, height, top, left, flex }}
      elevation={3}
    >
      <div
        className={titleSectionStyle || classes.boxTitle}
        style={{
          borderBottom: title && '1px solid lightgray',
          padding: !title && 0,
        }}
      >
        {title && (
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }} noWrap>
            {title}
          </Typography>
        )}
        {titleWidget}
        {/* {loader && <CircularProgress color="primary" />} */}
      </div>
      {widget}
      {pages > 1 && (
        <PagesStepper
          max={pages}
          currentStep={currentPage}
          handleChangeStep={handleChangePage}
        />
      )}
    </Paper>
  );
};

WidgetBox.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  top: PropTypes.string,
  left: PropTypes.string,
  title: PropTypes.string,
  widget: PropTypes.object,
  titleSectionStyle: PropTypes.object,
  titleWidget: PropTypes.object,
  flex: PropTypes.string,
  pages: PropTypes.number,
  currentPage: PropTypes.number,
  handleChangePage: PropTypes.func,
};

export default WidgetBox;
